import TenantConfigurationList from './TenantConfigurationList';
import TenantConfigurationEdit from './TenantConfigurationEdit';
import { TenantConfigurationIcon } from '../../core/themes/icons/TenantConfigurationIcon';

export default {
  list: TenantConfigurationList,
  edit: TenantConfigurationEdit,
  icon: TenantConfigurationIcon
};
